<template>
    <div class="permission-management">
      <!-- <h2>权限管理</h2> -->
      
      <!-- 顶部操作区域 -->
      <el-row :gutter="20" class="operation-area">
        <el-col :span="24">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="角色管理" name="roles">
              <div class="tab-toolbar">
                <el-button type="primary" icon="el-icon-plus" @click="handleAddRole">新增角色</el-button>
                <el-input
                  v-model="roleSearchKeyword"
                  placeholder="请输入角色名称"
                  style="width: 250px; margin-left: 10px"
                  prefix-icon="el-icon-search"
                  @input="handleRoleSearch"
                  clearable
                ></el-input>
              </div>
            </el-tab-pane>
            <el-tab-pane label="权限设置" name="permissions">
              <div class="tab-toolbar">
                <el-button type="primary" icon="el-icon-plus" @click="handleAddPermission">新增权限</el-button>
                <el-select v-model="permissionType" placeholder="权限类型" style="width: 140px; margin-left: 10px">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="菜单" value="menu"></el-option>
                  <el-option label="按钮" value="button"></el-option>
                  <el-option label="数据" value="data"></el-option>
                </el-select>
                <el-input
                  v-model="permissionSearchKeyword"
                  placeholder="请输入权限名称"
                  style="width: 250px; margin-left: 10px"
                  prefix-icon="el-icon-search"
                  @input="handlePermissionSearch"
                  clearable
                ></el-input>
              </div>
            </el-tab-pane>
            <el-tab-pane label="用户角色分配" name="assignment">
              <div class="tab-toolbar">
                <el-select v-model="departmentFilter" placeholder="科室筛选" style="width: 140px;">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="dept in departments" :key="dept.id" :label="dept.name" :value="dept.id"></el-option>
                </el-select>
                <el-select v-model="positionFilter" placeholder="岗位筛选" style="width: 140px; margin-left: 10px">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="医生" value="医生"></el-option>
                  <el-option label="项目管理员" value="项目管理员"></el-option>
                  <el-option label="护士" value="护士"></el-option>
                  <el-option label="个管师" value="个管师"></el-option>
                </el-select>
                <el-input
                  v-model="userSearchKeyword"
                  placeholder="请输入职工姓名或工号"
                  style="width: 250px; margin-left: 10px"
                  prefix-icon="el-icon-search"
                  @input="handleUserSearch"
                  clearable
                ></el-input>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      
      <!-- 角色管理表格 -->
      <el-table
        v-if="activeTab === 'roles'"
        :data="filteredRoles"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="角色名称" width="150"></el-table-column>
        <el-table-column prop="code" label="角色编码" width="150"></el-table-column>
        <el-table-column prop="description" label="角色描述"></el-table-column>
        <el-table-column prop="userCount" label="用户数量" width="100" sortable></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEditRole(scope.row)">编辑</el-button>
            <el-button size="mini" type="success" icon="el-icon-setting" @click="handleConfigPermission(scope.row)">配置权限</el-button>
            <el-button 
              size="mini" 
              type="danger" 
              icon="el-icon-delete" 
              :disabled="scope.row.isSystem === 1"
              @click="handleDeleteRole(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 权限设置表格 -->
      <el-table
        v-if="activeTab === 'permissions'"
        :data="filteredPermissions"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column prop="name" label="权限名称" width="180"></el-table-column>
        <el-table-column prop="code" label="权限编码" width="180"></el-table-column>
        <el-table-column prop="type" label="权限类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'menu'" type="success">菜单</el-tag>
            <el-tag v-else-if="scope.row.type === 'button'" type="warning">按钮</el-tag>
            <el-tag v-else-if="scope.row.type === 'data'" type="info">数据</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="path" label="路径"></el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.type === 'menu'" type="primary" icon="el-icon-plus" @click="handleAddSubPermission(scope.row)">新增</el-button>
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEditPermission(scope.row)">编辑</el-button>
            <el-button 
              size="mini" 
              type="danger" 
              icon="el-icon-delete" 
              :disabled="scope.row.isSystem === 1 || (scope.row.children && scope.row.children.length > 0)"
              @click="handleDeletePermission(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 用户角色分配表格 -->
      <el-table
        v-if="activeTab === 'assignment'"
        :data="filteredUsers"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="name" label="姓名" width="100">
          <template slot-scope="scope">
            <div class="user-name">
              <el-avatar :size="30" :src="scope.row.avatar"></el-avatar>
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="staffId" label="工号" width="100"></el-table-column>
        <el-table-column prop="department" label="所属科室" width="120"></el-table-column>
        <el-table-column prop="position" label="岗位" width="120"></el-table-column>
        <el-table-column prop="roles" label="已分配角色" width="280">
          <template slot-scope="scope">
            <el-tag v-for="role in scope.row.roles" :key="role.id" size="small" style="margin-right: 5px; margin-bottom: 5px">{{ role.name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="lastLoginTime" label="最近登录时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleAssignRoles(scope.row)">分配角色</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 角色对话框 -->
      <el-dialog
        :title="roleDialogType === 'add' ? '新增角色' : '编辑角色'"
        :visible.sync="roleDialogVisible"
        width="500px"
      >
        <el-form :model="roleForm" :rules="roleRules" ref="roleForm" label-width="100px">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="roleForm.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="roleForm.code" placeholder="请输入角色编码"></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="description">
            <el-input type="textarea" v-model="roleForm.description" :rows="4" placeholder="请输入角色描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitRoleForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 权限对话框 -->
      <el-dialog
        :title="permissionDialogType === 'add' ? '新增权限' : '编辑权限'"
        :visible.sync="permissionDialogVisible"
        width="500px"
      >
        <el-form :model="permissionForm" :rules="permissionRules" ref="permissionForm" label-width="100px">
          <el-form-item label="上级权限" prop="parentId" v-if="permissionDialogType === 'add'">
            <el-cascader
              v-model="permissionForm.parentId"
              :options="permissionTree"
              :props="{ checkStrictly: true, value: 'id', label: 'name' }"
              clearable
              placeholder="请选择上级权限"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="权限名称" prop="name">
            <el-input v-model="permissionForm.name" placeholder="请输入权限名称"></el-input>
          </el-form-item>
          <el-form-item label="权限编码" prop="code">
            <el-input v-model="permissionForm.code" placeholder="请输入权限编码"></el-input>
          </el-form-item>
          <el-form-item label="权限类型" prop="type">
            <el-radio-group v-model="permissionForm.type">
              <el-radio label="menu">菜单</el-radio>
              <el-radio label="button">按钮</el-radio>
              <el-radio label="data">数据</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="路径" prop="path" v-if="permissionForm.type === 'menu'">
            <el-input v-model="permissionForm.path" placeholder="请输入权限路径"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="icon" v-if="permissionForm.type === 'menu'">
            <el-input v-model="permissionForm.icon" placeholder="请输入图标类名">
              <template slot="append">
                <i :class="permissionForm.icon || 'el-icon-menu'"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="permissionForm.sort" :min="1" :max="999"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="permissionDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPermissionForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 配置权限对话框 -->
      <el-dialog
        title="配置权限"
        :visible.sync="configPermissionDialogVisible"
        width="600px"
      >
        <div v-if="currentRole">
          <h4>当前角色：{{ currentRole.name }}</h4>
          <el-tree
            ref="permissionTree"
            :data="permissionTreeData"
            :props="{ label: 'name', children: 'children' }"
            node-key="id"
            show-checkbox
            default-expand-all
          ></el-tree>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="configPermissionDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveRolePermissions">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 分配角色对话框 -->
      <el-dialog
        title="分配角色"
        :visible.sync="assignRoleDialogVisible"
        width="500px"
      >
        <div v-if="currentUser">
          <h4>当前用户：{{ currentUser.name }} ({{ currentUser.staffId }})</h4>
          <el-checkbox-group v-model="selectedRoles">
            <el-checkbox v-for="role in rolesList" :key="role.id" :label="role.id">
              {{ role.name }} <span class="role-description">{{ role.description }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="assignRoleDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveUserRoles">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'permission-management',
    data() {
      return {
        // 当前激活的标签页
        activeTab: 'roles',
        
        // 表格加载状态
        loading: false,
        
        // 搜索关键词
        roleSearchKeyword: '',
        permissionSearchKeyword: '',
        userSearchKeyword: '',
        
        // 筛选相关
        permissionType: '',
        departmentFilter: '',
        positionFilter: '',
        
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        
        // 角色对话框相关
        roleDialogVisible: false,
        roleDialogType: 'add', // 'add' 或 'edit'
        roleForm: {
          name: '',
          code: '',
          description: ''
        },
        roleRules: {
          name: [
            { required: true, message: '请输入角色名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入角色编码', trigger: 'blur' },
            { pattern: /^[A-Z_]+$/, message: '角色编码只能包含大写字母和下划线', trigger: 'blur' }
          ]
        },
        
        // 权限对话框相关
        permissionDialogVisible: false,
        permissionDialogType: 'add', // 'add' 或 'edit'
        permissionForm: {
          parentId: null,
          name: '',
          code: '',
          type: 'menu',
          path: '',
          icon: '',
          sort: 1
        },
        permissionRules: {
          name: [
            { required: true, message: '请输入权限名称', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入权限编码', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择权限类型', trigger: 'change' }
          ]
        },
        
        // 配置权限对话框相关
        configPermissionDialogVisible: false,
        currentRole: null,
        
        // 分配角色对话框相关
        assignRoleDialogVisible: false,
        currentUser: null,
        selectedRoles: [],
        
        // 角色列表数据
        rolesList: [
          {
            id: 1,
            name: '超级管理员',
            code: 'SUPER_ADMIN',
            description: '系统超级管理员，拥有所有权限',
            userCount: 1,
            isSystem: 1,
            createTime: '2023-01-01 00:00:00'
          },
          {
            id: 2,
            name: '医生角色',
            code: 'DOCTOR',
            description: '医生基础角色，能够访问患者信息、随访计划等',
            userCount: 35,
            isSystem: 1,
            createTime: '2023-01-02 10:30:00'
          },
          {
            id: 3,
            name: '护士角色',
            code: 'NURSE',
            description: '护士基础角色，可查看随访计划，执行护理任务',
            userCount: 48,
            isSystem: 1,
            createTime: '2023-01-03 11:20:00'
          },
          {
            id: 4,
            name: '个管师',
            code: 'CASE_MANAGER',
            description: '个案管理师角色，负责患者随访工作',
            userCount: 12,
            isSystem: 1,
            createTime: '2023-01-04 14:15:00'
          },
          {
            id: 5,
            name: '项目管理员',
            code: 'PROJECT_ADMIN',
            description: '项目管理员角色，负责项目配置和用户管理',
            userCount: 5,
            isSystem: 1,
            createTime: '2023-01-05 15:45:00'
          },
          {
            id: 6,
            name: '科室主任',
            code: 'DEPT_DIRECTOR',
            description: '科室主任角色，拥有科室管理员权限',
            userCount: 10,
            isSystem: 0,
            createTime: '2023-02-15 09:30:00'
          },
          {
            id: 7,
            name: '数据分析师',
            code: 'DATA_ANALYST',
            description: '数据分析师角色，可查看分析统计数据',
            userCount: 3,
            isSystem: 0,
            createTime: '2023-03-10 16:20:00'
          }
        ],
        
        // 权限列表数据 - 树形结构
        permissionsList: [
          {
            id: 1,
            name: '系统管理',
            code: 'SYSTEM_MANAGE',
            type: 'menu',
            path: '/system',
            icon: 'el-icon-setting',
            sort: 1,
            isSystem: 1,
            children: [
              {
                id: 11,
                name: '用户管理',
                code: 'USER_MANAGE',
                type: 'menu',
                path: '/system/user',
                icon: 'el-icon-user',
                sort: 1,
                isSystem: 1,
                children: [
                  {
                    id: 111,
                    name: '用户查询',
                    code: 'USER_QUERY',
                    type: 'button',
                    path: '',
                    sort: 1,
                    isSystem: 1
                  },
                  {
                    id: 112,
                    name: '用户新增',
                    code: 'USER_ADD',
                    type: 'button',
                    path: '',
                    sort: 2,
                    isSystem: 1
                  },
                  {
                    id: 113,
                    name: '用户编辑',
                    code: 'USER_EDIT',
                    type: 'button',
                    path: '',
                    sort: 3,
                    isSystem: 1
                  },
                  {
                    id: 114,
                    name: '用户删除',
                    code: 'USER_DELETE',
                    type: 'button',
                    path: '',
                    sort: 4,
                    isSystem: 1
                  }
                ]
              },
              {
                id: 12,
                name: '角色管理',
                code: 'ROLE_MANAGE',
                type: 'menu',
                path: '/system/role',
                icon: 'el-icon-s-check',
                sort: 2,
                isSystem: 1,
                children: [
                  {
                    id: 121,
                    name: '角色查询',
                    code: 'ROLE_QUERY',
                    type: 'button',
                    path: '',
                    sort: 1,
                    isSystem: 1
                  },
                  {
                    id: 122,
                    name: '角色新增',
                    code: 'ROLE_ADD',
                    type: 'button',
                    path: '',
                    sort: 2,
                    isSystem: 1
                  },
                  {
                    id: 123,
                    name: '角色编辑',
                    code: 'ROLE_EDIT',
                    type: 'button',
                    path: '',
                    sort: 3,
                    isSystem: 1
                  },
                  {
                    id: 124,
                    name: '角色删除',
                    code: 'ROLE_DELETE',
                    type: 'button',
                    path: '',
                    sort: 4,
                    isSystem: 1
                  },
                  {
                    id: 125,
                    name: '权限分配',
                    code: 'ROLE_ASSIGN_PERM',
                    type: 'button',
                    path: '',
                    sort: 5,
                    isSystem: 1
                  }
                ]
              }
            ]
          },
          {
            id: 2,
            name: '随访管理',
            code: 'FOLLOW_UP_MANAGE',
            type: 'menu',
            path: '/followup',
            icon: 'el-icon-date',
            sort: 2,
            isSystem: 1,
            children: [
              {
                id: 21,
                name: '随访计划',
                code: 'FOLLOW_UP_PLAN',
                type: 'menu',
                path: '/followup/plan',
                icon: 'el-icon-tickets',
                sort: 1,
                isSystem: 1
              },
              {
                id: 22,
                name: '随访任务',
                code: 'FOLLOW_UP_TASK',
                type: 'menu',
                path: '/followup/task',
                icon: 'el-icon-notebook-2',
                sort: 2,
                isSystem: 1
              },
              {
                id: 23,
                name: '随访统计',
                code: 'FOLLOW_UP_STATS',
                type: 'menu',
                path: '/followup/stats',
                icon: 'el-icon-data-analysis',
                sort: 3,
                isSystem: 1
              }
            ]
          },
          {
            id: 3,
            name: '患者管理',
            code: 'PATIENT_MANAGE',
            type: 'menu',
            path: '/patient',
            icon: 'el-icon-s-custom',
            sort: 3,
            isSystem: 1,
            children: [
              {
                id: 31,
                name: '患者档案',
                code: 'PATIENT_PROFILE',
                type: 'menu',
                path: '/patient/profile',
                icon: 'el-icon-document',
                sort: 1,
                isSystem: 1,
                children: [
                  {
                    id: 311,
                    name: '全部患者',
                    code: 'PATIENT_ALL',
                    type: 'data',
                    path: '',
                    sort: 1,
                    isSystem: 1
                  },
                  {
                    id: 312,
                    name: '本科室患者',
                    code: 'PATIENT_DEPT',
                    type: 'data',
                    path: '',
                    sort: 2,
                    isSystem: 1
                  },
                  {
                    id: 313,
                    name: '个人患者',
                    code: 'PATIENT_OWN',
                    type: 'data',
                    path: '',
                    sort: 3,
                    isSystem: 1
                  }
                ]
              },
              {
                id: 32,
                name: '患者套餐',
                code: 'PATIENT_PACKAGE',
                type: 'menu',
                path: '/patient/package',
                icon: 'el-icon-s-order',
                sort: 2,
                isSystem: 1
              }
            ]
          }
        ],
        
        // 科室数据
        departments: [
          { id: 1, name: '内科' },
          { id: 2, name: '外科' },
          { id: 3, name: '妇产科' },
          { id: 4, name: '儿科' },
          { id: 5, name: '行政部' },
          { id: 6, name: '随访中心' }
        ],
        
        // 用户列表数据
        usersList: [
          {
            id: 1,
            name: '许昊然',
            staffId: 'DR001',
            position: '医生',
            department: '内科',
            departmentId: 1,
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            lastLoginTime: '2023-05-20 08:30:15',
            roles: [
              { id: 2, name: '医生角色' },
              { id: 6, name: '科室主任' }
            ]
          },
          {
            id: 2,
            name: '苏雅婷',
            staffId: 'DR002',
            position: '医生',
            department: '外科',
            departmentId: 2,
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            lastLoginTime: '2023-05-19 15:20:30',
            roles: [
              { id: 2, name: '医生角色' }
            ]
          },
          {
            id: 3,
            name: '林书辰',
            staffId: 'NR001',
            position: '护士',
            department: '内科',
            departmentId: 1,
            avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            lastLoginTime: '2023-05-18 09:15:45',
            roles: [
              { id: 3, name: '护士角色' }
            ]
          },
          {
            id: 4,
            name: '程若曦',
            staffId: 'PM001',
            position: '项目管理员',
            department: '行政部',
            departmentId: 5,
            avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            lastLoginTime: '2023-05-20 10:30:20',
            roles: [
              { id: 5, name: '项目管理员' },
              { id: 1, name: '超级管理员' }
            ]
          },
          {
            id: 5,
            name: '郭子轩',
            staffId: 'CM001',
            position: '个管师',
            department: '随访中心',
            departmentId: 6,
            avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
            lastLoginTime: '2023-05-19 11:45:10',
            roles: [
              { id: 4, name: '个管师' }
            ]
          }
        ]
      }
    },
    computed: {
      // 角色过滤
      filteredRoles() {
        if (!this.roleSearchKeyword) {
          return this.rolesList;
        }
        
        const keyword = this.roleSearchKeyword.toLowerCase();
        return this.rolesList.filter(role => 
          role.name.toLowerCase().includes(keyword) || 
          role.code.toLowerCase().includes(keyword)
        );
      },
      
      // 权限过滤 - 扁平化处理
      filteredPermissions() {
        let result = JSON.parse(JSON.stringify(this.permissionsList));
        
        // 权限类型筛选
        if (this.permissionType) {
          const filterByType = (items) => {
            return items.filter(item => {
              if (item.children && item.children.length > 0) {
                item.children = filterByType(item.children);
              }
              return item.type === this.permissionType || (item.children && item.children.length > 0);
            });
          };
          result = filterByType(result);
        }
        
        // 关键词筛选
        if (this.permissionSearchKeyword) {
          const keyword = this.permissionSearchKeyword.toLowerCase();
          const filterByKeyword = (items) => {
            return items.filter(item => {
              if (item.children && item.children.length > 0) {
                item.children = filterByKeyword(item.children);
              }
              return item.name.toLowerCase().includes(keyword) || 
                    item.code.toLowerCase().includes(keyword) || 
                    (item.children && item.children.length > 0);
            });
          };
          result = filterByKeyword(result);
        }
        
        return result;
      },
      
      // 用户过滤
      filteredUsers() {
        let result = this.usersList;
        
        // 关键词筛选
        if (this.userSearchKeyword) {
          const keyword = this.userSearchKeyword.toLowerCase();
          result = result.filter(user => 
            user.name.toLowerCase().includes(keyword) || 
            user.staffId.toLowerCase().includes(keyword)
          );
        }
        
        // 科室筛选
        if (this.departmentFilter) {
          result = result.filter(user => user.departmentId === this.departmentFilter);
        }
        
        // 岗位筛选
        if (this.positionFilter) {
          result = result.filter(user => user.position === this.positionFilter);
        }
        
        this.totalCount = result.length;
        return result;
      },
      
      // 权限树形数据 - 用于配置权限
      permissionTreeData() {
        return JSON.parse(JSON.stringify(this.permissionsList));
      },
      
      // 权限下拉选择树 - 用于新增权限选择上级
      permissionTree() {
        const getMenus = (list) => {
          const result = [];
          list.forEach(item => {
            if (item.type === 'menu') {
              const node = {
                id: item.id,
                name: item.name,
                children: item.children ? getMenus(item.children) : []
              };
              result.push(node);
            }
          });
          return result;
        };
        
        const rootNode = [{
          id: 0,
          name: '作为顶级菜单',
          children: getMenus(this.permissionsList)
        }];
        
        return rootNode;
      }
    },
    created() {
      this.totalCount = this.rolesList.length;
    },
    methods: {
      // 标签页切换
      handleTabClick(tab) {
        this.currentPage = 1;
        switch (tab.name) {
          case 'roles':
            this.totalCount = this.filteredRoles.length;
            break;
          case 'permissions':
            // 权限是树形结构，不需要分页
            break;
          case 'assignment':
            this.totalCount = this.filteredUsers.length;
            break;
        }
      },
      
      // 搜索处理
      handleRoleSearch() {
        this.currentPage = 1;
        this.totalCount = this.filteredRoles.length;
      },
      handlePermissionSearch() {
        // 权限是树形结构，不需要分页
      },
      handleUserSearch() {
        this.currentPage = 1;
        this.totalCount = this.filteredUsers.length;
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 角色管理相关方法
      handleAddRole() {
        this.roleDialogType = 'add';
        this.roleForm = {
          name: '',
          code: '',
          description: ''
        };
        this.roleDialogVisible = true;
        
        // 确保表单验证重置
        this.$nextTick(() => {
          if (this.$refs.roleForm) {
            this.$refs.roleForm.resetFields();
          }
        });
      },
      
      handleEditRole(row) {
        this.roleDialogType = 'edit';
        this.roleForm = { ...row };
        this.roleDialogVisible = true;
      },
      
      handleDeleteRole(row) {
        if (row.isSystem === 1) {
          this.$message.warning('系统角色不能删除');
          return;
        }
        
        this.$confirm('确定要删除该角色吗？删除后将解除所有用户与该角色的关联', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          const index = this.rolesList.findIndex(role => role.id === row.id);
          if (index !== -1) {
            this.rolesList.splice(index, 1);
            this.$message.success('删除成功');
            this.totalCount--;
          }
        }).catch(() => {
          // 取消删除
        });
      },
      
      submitRoleForm() {
        this.$refs.roleForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              if (this.roleDialogType === 'add') {
                // 模拟添加成功
                const newRole = {
                  ...this.roleForm,
                  id: this.rolesList.length + 1,
                  userCount: 0,
                  isSystem: 0,
                  createTime: new Date().toLocaleString()
                };
                this.rolesList.push(newRole);
                this.totalCount++;
                this.$message.success('角色添加成功');
              } else {
                // 模拟编辑成功
                const index = this.rolesList.findIndex(role => role.id === this.roleForm.id);
                if (index !== -1) {
                  const { userCount, isSystem, createTime } = this.rolesList[index];
                  this.rolesList[index] = {
                    ...this.roleForm,
                    userCount,
                    isSystem,
                    createTime
                  };
                  this.$message.success('角色编辑成功');
                }
              }
              this.loading = false;
              this.roleDialogVisible = false;
            }, 500);
          } else {
            return false;
          }
        });
      },
      
      // 配置权限相关
      handleConfigPermission(row) {
        this.currentRole = row;
        this.configPermissionDialogVisible = true;
        
        // 模拟已有权限，实际应从API获取
        this.$nextTick(() => {
          if (this.$refs.permissionTree) {
            if (row.id === 1) { // 超级管理员拥有所有权限
              const allKeys = this.getAllPermissionIds(this.permissionsList);
              this.$refs.permissionTree.setCheckedKeys(allKeys);
            } else if (row.id === 2) { // 医生角色
              this.$refs.permissionTree.setCheckedKeys([2, 21, 22, 3, 31, 313]);
            } else if (row.id === 3) { // 护士角色
              this.$refs.permissionTree.setCheckedKeys([2, 21, 22]);
            } else {
              this.$refs.permissionTree.setCheckedKeys([]);
            }
          }
        });
      },
      
      getAllPermissionIds(permissions) {
        let ids = [];
        permissions.forEach(item => {
          ids.push(item.id);
          if (item.children && item.children.length > 0) {
            ids = ids.concat(this.getAllPermissionIds(item.children));
          }
        });
        return ids;
      },
      
      saveRolePermissions() {
        const checkedKeys = this.$refs.permissionTree.getCheckedKeys();
        const halfCheckedKeys = this.$refs.permissionTree.getHalfCheckedKeys();
        const allKeys = [...checkedKeys, ...halfCheckedKeys];
        
        this.$message.success(`角色【${this.currentRole.name}】权限配置成功，共分配${allKeys.length}个权限`);
        this.configPermissionDialogVisible = false;
      },
      
      // 权限管理相关方法
      handleAddPermission() {
        this.permissionDialogType = 'add';
        this.permissionForm = {
          parentId: null,
          name: '',
          code: '',
          type: 'menu',
          path: '',
          icon: 'el-icon-menu',
          sort: 1
        };
        this.permissionDialogVisible = true;
        
        // 确保表单验证重置
        this.$nextTick(() => {
          if (this.$refs.permissionForm) {
            this.$refs.permissionForm.resetFields();
          }
        });
      },
      
      handleAddSubPermission(row) {
        this.permissionDialogType = 'add';
        this.permissionForm = {
          parentId: [0, row.id], // 级联选择器的值格式
          name: '',
          code: '',
          type: 'menu',
          path: '',
          icon: 'el-icon-menu',
          sort: 1
        };
        this.permissionDialogVisible = true;
        
        // 确保表单验证重置
        this.$nextTick(() => {
          if (this.$refs.permissionForm) {
            this.$refs.permissionForm.resetFields();
          }
        });
      },
      
      handleEditPermission(row) {
        this.permissionDialogType = 'edit';
        this.permissionForm = { ...row };
        this.permissionDialogVisible = true;
      },
      
      handleDeletePermission(row) {
        if (row.isSystem === 1) {
          this.$message.warning('系统权限不能删除');
          return;
        }
        
        if (row.children && row.children.length > 0) {
          this.$message.warning('该权限下有子权限，不能删除');
          return;
        }
        
        this.$confirm('确定要删除该权限吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          this.$message.success('删除成功');
          // 实际应用中需要递归查找并删除，这里省略
        }).catch(() => {
          // 取消删除
        });
      },
      
      submitPermissionForm() {
        this.$refs.permissionForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              this.$message.success(this.permissionDialogType === 'add' ? '权限添加成功' : '权限编辑成功');
              this.loading = false;
              this.permissionDialogVisible = false;
            }, 500);
          } else {
            return false;
          }
        });
      },
      
      // 用户角色分配相关方法
      handleAssignRoles(row) {
        this.currentUser = row;
        this.assignRoleDialogVisible = true;
        // 设置当前用户已有的角色
        this.selectedRoles = row.roles.map(role => role.id);
      },
      
      saveUserRoles() {
        // 模拟保存成功
        const roleNames = this.selectedRoles.map(id => {
          const role = this.rolesList.find(r => r.id === id);
          return role ? role.name : '';
        }).filter(name => name);
        
        // 更新用户的角色显示
        const userIndex = this.usersList.findIndex(u => u.id === this.currentUser.id);
        if (userIndex !== -1) {
          const roles = this.selectedRoles.map(id => {
            const role = this.rolesList.find(r => r.id === id);
            return role ? { id: role.id, name: role.name } : null;
          }).filter(role => role);
          
          this.usersList[userIndex].roles = roles;
        }
        
        this.$message.success(`用户【${this.currentUser.name}】角色分配成功，已分配角色：${roleNames.join(', ')}`);
        this.assignRoleDialogVisible = false;
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .permission-management {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .operation-area {
      margin-bottom: 15px;
    }
    
    .tab-toolbar {
      padding: 10px 0;
      display: flex;
      align-items: center;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .user-name {
      display: flex;
      align-items: center;
    }
    
    .role-description {
      color: #909399;
      font-size: 12px;
      margin-left: 5px;
    }
    
    ::v-deep .el-tabs__content {
      display: none;
    }
    
    ::v-deep .el-checkbox-group {
      display: flex;
      flex-direction: column;
      
      .el-checkbox {
        margin-left: 0;
        margin-bottom: 10px;
      }
    }
  }
  </style>